import Mobile from "./mobile";
import Web from "./web";
import "./styles/footer.css";

const ContentFooter = ({ footerWeb, footerMob }) => {
  return (
    <footer>
      <div className="d-none d-lg-block">{footerWeb ? <Web /> : false}</div>
      <div className="d-block d-lg-none">{footerMob ? <Mobile /> : false}</div>
    </footer>
  );
};

export default ContentFooter;
